import { useState } from 'react';
import { BarcodePicker } from 'scandit-sdk';
import scan_check_icon from '../../styles/img/code_qr_icon_scan_check .svg';
import Scanner from '../../components/Scanner';
import ScannerTest from '../../scanner/ScannerTest';

import { ReloadPage } from '../../components/tile/ReloadPage';
import { vidercache } from '../../utils/ClearCache';
import { useScanditSettings } from './hooks/useScanditSettings';

const ScannerContainer = ({
  isPWA,
  isScanditLoaded,
  isDestroy,
  onScan,
  onExplanationClick
}) => {
  const { getScanSettings } = useScanditSettings();
  const isPaused = false;

  const [isLoadingScanner, setIsLoadingScanner] = useState(true);

  return (
    <div className={'popupcheckscan'}>
      <div className="absolute z-[1000] flex flex-col top-8 items-center gap-5 appear overflow-hidden">
        <div className="flex flex-col justify-center items-center gap-[0.8em]">
          <img src={scan_check_icon} alt="scan" className="w-[85%]" />
        </div>
      </div>

      <div className="flex items-center justify-center w-full h-full overflow-hidden bg-black">
        {isPWA
          ? isScanditLoaded && (
              <ScannerTest
                isViewFinderSquare={true}
                addTopMargin={30}
                preloadBlurryRecognition={true}
                preloadEngine={true}
                accessCamera={true}
                guiStyle={BarcodePicker.GuiStyle.VIEWFINDER}
                setIsLoadingScanner={setIsLoadingScanner}
                viewFinderArea={{
                  x: 0.2,
                  y: 0.23,
                  width: 0.6,
                  height: 0.3,
                }}
                onScan={onScan}
                pause={isPaused}
                destroy={isDestroy}
                onProcessFramze
                scanSettings={getScanSettings()}
                videoFit={BarcodePicker.ObjectFit.COVER}
                playSoundOnScan={true}
                enableCameraSwitcher={false}
                enablePinchToZoom={false}
                enableTapToFocus={true}
                enableTorchToggle={false}
                mirrorImage={true}
                targetScanningFPS={10}
                zoom={0}
                size={240}
              />
            )
          : isScanditLoaded && (
              <Scanner
                preloadBlurryRecognition={true}
                preloadEngine={true}
                accessCamera={true}
                guiStyle={BarcodePicker.GuiStyle.VIEWFINDER}
                isLoading={isLoadingScanner}
                setIsLoading={setIsLoadingScanner}
                viewFinderArea={{
                  x: 0.12,
                  y: 0.34,
                  width: 0.74,
                  height: 0.4,
                }}
                onScan={onScan}
                pause={isPaused}
                destroy={isDestroy}
                onProcessFrame
                scanSettings={getScanSettings()}
                videoFit={BarcodePicker.ObjectFit.COVER}
                playSoundOnScan={true}
                enableCameraSwitcher={false}
                enablePinchToZoom={false}
                enableTapToFocus={true}
                enableTorchToggle={false}
                mirrorImage={true}
                targetScanningFPS={10}
                zoom={0}
              />
            )}
      </div>

      <button
        type="button"
        className="fixed bottom-14 z-[1000] explicationcheck"
        onClick={onExplanationClick}
      >
        Besoin d'aide ?
      </button>
      <ReloadPage
        onClick={vidercache}
        titre="Un problème de scanner ?"
        message={'Actualiser la page'}
        position={'bottom'}
      />
    </div>
  );
};

export default ScannerContainer;